export function ShowAnimeInfo(anime) {
    console.log(anime.genres)
    return (
        <div className="container p-2 rounded-md border-[0.5px] border-orange-400 flex flex-row flex-nowrap gap-2">
            <a rel="noreferrer" target="_blank" href={"https://www.themoviedb.org/movie/" + anime.id} class="shrink-0 relative w-[200px] mb-5">
                <img loading="lazy" className="rounded-md" src={"https://image.tmdb.org/t/p/w500" + anime.poster_path} alt={anime.title} width="200px" />
            </a>

            <div className="flex flex-col gap-2 w-full">
                <div className="flex flex-row flex-wrap gap-4">
                    <h1 class="text-2xl font-bold font-sans">{anime.title}</h1>
                    <div className="px-2 py-1.5 bg-zinc-700 rounded-full">{anime.original_language.toUpperCase()}</div>
                </div>
                <hr />
                <div>
                    <h1 className="text-lg font-semibold">Résumé</h1>
                    <p className="text-gray-400">{anime.overview}</p>
                </div>
                <div>
                    <h1 className="text-lg font-semibold">Genres</h1>
                    <p className="text-gray-400">{anime.genres && anime.genres.length > 0 ? anime.genres.join(", ") : ""}</p>
                </div>
                <div>

                    <h1 className="text-lg font-semibold">Date</h1>
                    <p className="text-gray-400">{anime.release_date}</p>
                </div>
                <div>

                    <h1 className="text-lg font-semibold">Note</h1>
                    <p className="text-gray-400">{anime.vote_average}/10 ({anime.vote_count} votants)</p>
                </div>
            </div>
        </div >
    )
}